export const categories = [
  {
    key: 'lietuvoje',
    name: 'Lietuvos naujienos',
    categories: [7, 138, 904, 79028927],
  },
  {
    key: 'gamta',
    name: 'Gamta',
    categories: [116, 905],
  },
  {
    key: 'kriminalai',
    name: 'Kriminalai',
    categories: [5995],
  },
  {
    key: 'pasaulis',
    name: 'Pasaulio naujienos',
    categories: [8, 79298779],
  },
  {
    key: 'sveikata',
    name: 'Sveikata',
    categories: [112],
  },
  {
    key: 'maistas',
    name: 'Maistas',
    categories: [105, 130],
  },
  {
    key: 'gyvenimas',
    name: 'Gyvenimas',
    categories: [400],
  },
  {
    key: 'seima',
    name: 'Šeima',
    categories: [135],
  },
  {
    key: 'psichologija',
    name: 'Psichologija',
    categories: [404],
  },
  {
    key: 'kultura',
    name: 'Kultūra',
    categories: [140],
  },
  {
    key: 'sportas',
    name: 'Sportas',
    categories: [117, 903],
  },
  {
    key: 'tinklalaides',
    name: 'Delfi Fone',
    categories: [96603927, 96603920],
  },
  {
    key: 'konferencijos',
    name: 'Konferencijos',
    categories: [94572425],
  },
  {
    key: 'video',
    name: 'Video',
    categories: [107],
  },
  {
    key: 'rinkodara',
    name: 'Rinkodara',
    categories: [120],
  },
  {
    key: 'stilius',
    name: 'Stilius',
    categories: [96604228],
  },
  {
    key: 'veidai',
    name: 'Veidai',
    categories: [96604228, 134, 906],
  },
  {
    key: 'transportas',
    name: 'Transportas',
    categories: [600, 60374333],
  },
  {
    key: 'agro',
    name: 'Agroverslas',
    categories: [133],
  },
  {
    key: 'bustas',
    name: 'Nekilnojamas turtas',
    categories: [132],
  },
  {
    key: 'mokslas',
    name: 'Mokslas',
    categories: [908],
  },
  {
    key: 'verslas',
    name: 'Verslas',
    categories: [907],
  },
  {
    key: 'saugumas',
    name: 'Saugumas ir gynyba ',
    categories: [148, 72032190, 79440681],
  },
  {
    key: 'laisvalaikis',
    name: 'Laisvalaikis',
    categories: [126, 131],
  },
  {
    key: 'zinios-visiems',
    name: 'Žinios visiems',
    categories: [96604489],
  },
];
